import API from "../global/api";

export const requestUserID = (data) => {
  return {
    type: "REQUEST_USER_ID",
  };
};
export const successUserID = (data) => {
  return {
    type: "SUCCESS_USER_ID",
    payload: data,
  };
};
export const successDeleteDivorce = (data) => {
  return {
    type: "SUCCESS_DELETE_DIVORCE",
    payload: data,
  };
};
export const errorUserID = (data) => {
  return {
    type: "ERROR_USER_ID",
    payload: data,
  };
};

export const errorDeleteDivorce = (data) => {
  return {
    type: "ERROR_DELETE_DIVORCE",
    payload: data,
  };
};

export const postUserID = (data) => {
  requestUserID();
  return (dispatch) => {
    API.post(`users/get-all-ids`,data).then((res) => {
    let data = [];
     data = res.data;
      dispatch(successUserID(data));
    });
  };
};


export const deleteDivorce = (data) => {
  return (dispatch) => {
    API.post(`petitional/delete-divorce-data`,data).then((res) => {
    let resData = [];
    resData = res.data;
      dispatch(successDeleteDivorce(data));
    });
  };
};